import React, { useState, useEffect } from "react";
import {
  Backdrop,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  Modal,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import gifg from "../../assets/icon/7efs.gif";
import { useNavigate, useParams } from "react-router-dom";
import CustomInput from "../../Component/common/CustomInput";
import guest from "../../assets/icon/guest.svg";
import {
  getSingleTicket,
  getTicketCharges,
  sendBookingNonTicketed,
} from "../../api";

import { sendBooking } from "../../api";
import { TiMinus } from "react-icons/ti";
import { TiPlus } from "react-icons/ti";
import { EVENT_SHIRO } from "../Home";
import DietaryOptions from "../../Component/common/DietaryOptions";

function generateUniqueCode(prefix = "web_") {
  const timestamp = Date.now().toString();

  const randomChars = Math.random().toString(36).substring(2, 6).toUpperCase();

  return `${prefix}${timestamp}${randomChars}`;
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { lg: 400, md: 400, sm: 350, xs: 300 },
  bgcolor: "background.paper",

  boxShadow: 24,
  p: 0,
  borderRadius: "12px",
};

const Booking = ({ event, ticket_id, selectedTickets = [], setStep, time, date, tax, isTicketed }) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const { id, name } = useParams();
  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
    setSuccessful(false);
    setErrorMessage(null);
    if (typeof setStep === "function") {
      setStep();
    } else if (name && id) {
      navigate(`/event/${name}/${id}`);
    }
  };

  

  // Ensure page scrolls to top whenever Booking is shown
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const [isSuccessful, setSuccessful] = useState(false);

  const [count, setCount] = useState(1); // used for single-ticket or non-ticketed flows
  const [email, setEmail] = useState("");
  const [amount, setAmount] = useState(1000);
  const [totalPrice, setTotalPrice] = useState(1000);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isloading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [referalCode, setReferalCode] = useState("");
  const [Dietary, setDietary] = useState([]);
  const [specialRequest, setSpecialRequest] = useState("");

  const isGoodMovesTuesday = name === "Good-Moves-Tuesday-";
  const chessLevels = ["Beginner", "Intermediate", "Pro"];

  const isMultiTicket = selectedTickets && selectedTickets.length > 0;

  const [ticketQuantities, setTicketQuantities] = useState(() => {
    const initial = {};
    if (isMultiTicket) {
      selectedTickets.forEach((ticket) => {
        initial[ticket.TicketId] = ticket.Quantity || 1;
      });
    }
    return initial;
  });

  useEffect(() => {
    setTotalPrice(amount * count);
  }, [count]);

  const validateEmail = (email) => {
    // Regular expression for basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleInputChange = (e) => {
    const { value } = e.target;
    setEmail(value);
    setError(!validateEmail(value)); // Set error if email is not valid
  };

  const [confirmEmail, setConfirmEmail] = useState("");
  const [confirmError, setConfirmError] = useState(false);

  useEffect(() => {
    if (email === confirmEmail) {
      setConfirmError(false);
    } else setConfirmError(true);
  }, [confirmEmail, email]);

  const isHouse = id === "4d44db8b-5f2e-4f15-95af-fecf72fdfb87";
  const isLoungeSessions = name === "The-Lounge-Sessions";
  // Lounge Sessions shares the House restaurant id — check name first
  const maxTicketCount = isLoungeSessions ? 1 : isHouse ? 2 : null;

  useEffect(() => {
    if (maxTicketCount && count > maxTicketCount) {
      setCount(maxTicketCount);
    }
  }, [maxTicketCount, count]);

  const handleAdd = () => {
    if (maxTicketCount && count >= maxTicketCount) return;
    if (isTicketed) {
      if (data?.TicketLeft > count) {
        setCount((count) => count + 1);
      }
    } else {
      setCount((count) => count + 1);
    }
  };
  const handleSub = () => {
    if (count > 1) {
      setCount((count) => count - 1);
    }
  };

  useEffect(() => {
    setTotalPrice(amount * count);
  }, [count]);


  const handleIncreaseQuantity = (ticketId, maxLeft) => {
    setTicketQuantities((prev) => {
      const current = prev[ticketId] || 0;

      if (maxTicketCount) {
        const total = Object.values(prev).reduce((sum, q) => sum + q, 0);
        if (total >= maxTicketCount) return prev;
      }

      if (maxLeft && current >= maxLeft) {
        return prev;
      }

      return {
        ...prev,
        [ticketId]: current + 1,
      };
    });
  };

  const handleDecreaseQuantity = (ticketId) => {
    setTicketQuantities((prev) => {
      const current = prev[ticketId] || 0;
      if (current <= 1) {
        return prev;
      }
      return { ...prev, [ticketId]: current - 1 };
    });
  };



  const handlegetSingleTicket = async () => {
    setLoading(true);
    await getSingleTicket(ticket_id)
      .then((res) => {
        setLoading(false);
        setData(res.data.result);
        // console.log(res);
      })
      .catch((err) => {
        // console.log(err);
        setLoading(false);
      });
  };
  const [charges, setCharges] = useState("");
  const [chargeLoading, setChargeLoading] = useState(false);

  const res_id = localStorage.getItem("userInfo");

  const chargesPayload = selectedTickets.map((ticket) => ({
    perTicketCost: ticket.TicketCost,
    partySize: ticketQuantities[ticket.TicketId] || 0,
  }));


  const handleGetTicketCharges = async () => {
    setChargeLoading(true);
    await getTicketCharges(id, chargesPayload, tax)
      .then((res) => {
        setChargeLoading(false);
        // console.log(res, "CHARGES");
        setCharges(res?.data?.result);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    if (!isMultiTicket && ticket_id) {
      handlegetSingleTicket();
    }
  }, [id, isMultiTicket, ticket_id]);

  useEffect(() => {
    if (!isMultiTicket && data) {
      setAmount(parseInt(data?.TicketPrice));
      setTotalPrice(parseInt(data?.TicketPrice));
    }
  }, [data, isMultiTicket]);

  const isShiroEvent = name === EVENT_SHIRO;
  const [errorMessage, setErrorMessage] = useState("");

  const totalSelectedQuantity = isMultiTicket
    ? selectedTickets.reduce(
        (sum, ticket) => sum + (ticketQuantities[ticket.TicketId] || 0),
        0,
      )
    : count;

  const multiTicketSubtotal = isMultiTicket
    ? selectedTickets.reduce(
        (sum, ticket) =>
          sum +
          (ticket.TicketCost || 0) * (ticketQuantities[ticket.TicketId] || 0),
        0,
      )
    : totalPrice;

  const payableTotal = isMultiTicket ? multiTicketSubtotal : totalPrice;
  const orderTotal =
    charges?.TotalTaxedPrice ?? charges?.TotalPrice ?? payableTotal;
  const isFreeEvent = Number(orderTotal) === 0;

  useEffect(() => {
    if (amount && count) {
      handleGetTicketCharges();
    }
  }, [amount, count, multiTicketSubtotal]);

  const config = {
    reference: new Date().getTime().toString(),
    email: email,
    amount: payableTotal * 100, //Amount is in the country's lowest currency. E.g Kobo, so 20000 kobo = N200
    publicKey: process.env.REACT_APP_PAYSTACK_CODE,
    // publicKey: "pk_test_6c0b3d295bf7fd5d570b36fdfde7a6c5efcc9a73",
    firstName: firstName,
    lastName: lastName,
  };

  const ticketsPayload = selectedTickets.map((ticket) => ({
    ticketId: ticket.TicketId,
    noOfGuest: ticketQuantities[ticket.TicketId] || 0,
  }));

  const bookingLastName =
    isGoodMovesTuesday && referalCode
      ? `${lastName} - ${referalCode}`
      : lastName;

  const dietaryRestriction = Array.isArray(Dietary)
    ? Dietary.join(", ")
    : "";

  const handleSendBooking = async () => {
    // Free events skip Paystack access_code and book directly
    if (isFreeEvent) {
      await handleSendBookingNoPayment();
      return;
    }

    const ref = generateUniqueCode();
    setOpen(false);
    setIsLoading(true);

    try {
      const res = await sendBooking(
        event,
        ticketsPayload,
        firstName,
        bookingLastName,
        email,
        phone,
        referalCode,
        dietaryRestriction,
        specialRequest,
        charges?.TotalTaxedPrice * 100,
        "Card",
        ref,
        time,
        date,
      );

      if (res?.data?.status) {
        window.location.href = res?.data?.result?.authorization_url;
      } else {
        setErrorMessage(res?.data?.error_message);
        setOpen(true);
      }
    } catch (err) {
      setErrorMessage(err?.message || "Something went wrong");
      setOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSendBookingNoPayment = async () => {
    setOpen(false);
    setSuccessful(false);
    setIsLoading(true);
    setErrorMessage(null);

    try {
      const res = await sendBookingNonTicketed(
        event,
        ticketsPayload,
        firstName,
        bookingLastName,
        email,
        phone,
        referalCode,
        dietaryRestriction,
        specialRequest,
        time,
        totalSelectedQuantity || count,
        date,
      );

      if (res?.data?.status) {
        setSuccessful(true);
        setOpen(true);
      } else {
        setErrorMessage(res?.data?.error_message);
        setOpen(true);
        setSuccessful(false);
      }
    } catch (err) {
      setErrorMessage(err?.message || "Something went wrong");
      setOpen(true);
      setSuccessful(false);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Box sx={{ mt: 3, minHeight: "1100px", px: 2 }}>
        <Grid
          container
          spacing={4}
          sx={{
            display: "flex",
            flexDirection: { xs: "column-reverse" },
          }}
        >
          <Grid item md={12}>
            <Box>
              <Box
                sx={{
                  bgcolor: "#fff",
                  p: 2,
                  py: 3,
                  border: "1px solid #DADADA",
                  borderRadius: "8px 8px 0px 0px",
                }}
              >
                <Typography
                  sx={{ color: "#2B2B2B", fontWeight: 700, fontSize: "13px" }}
                >
                  Contact Details
                </Typography>
              </Box>
              <Box
                sx={{
                  bgcolor: "#fff",
                  p: 2,
                  pb: 4,
                  border: "1px solid #DADADA",
                  borderRadius: "0px 0px 8px 8px",
                }}
              >
                <Grid container spacing={2}>
                  <Grid item md={12} xs={12}>
                    <CustomInput
                      label="First Name *"
                      placeholder="First Name"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                    />
                  </Grid>
                  <Grid item md={12} xs={12}>
                    <CustomInput
                      label="Last Name *"
                      placeholder="Last Name"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                    />
                  </Grid>
                  <Grid item md={12} xs={12}>
                    <CustomInput
                      label="Email Address *"
                      placeholder="Email Address"
                      value={email}
                      error={error}
                      helperText={error ? "Email must be valid" : ""}
                      onChange={handleInputChange}
                    />
                  </Grid>
                  <Grid item md={12} xs={12}>
                    <CustomInput
                      label="Confirm Email Address *"
                      placeholder="Email Address"
                      value={confirmEmail}
                      error={confirmError}
                      helperText={confirmError ? "Emails do not match" : ""}
                      onChange={(e) => setConfirmEmail(e.target.value)}
                    />
                  </Grid>
                  <Grid item md={12} xs={12}>
                    <CustomInput
                      label="Phone Number *"
                      placeholder="Phone Number "
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                    />
                  </Grid>
                  <Grid item md={12} xs={12}>
                    <Box
                      sx={{
                        mt: 2,
                        borderRadius: "10px",
                        border: "1px solid #d7d7d7",
                        p: 2,
                      }}
                    >
                      {/* <Typography
                            sx={{ fontWeight: 500, fontSize: '12px' }}
                          >
                            What occasion are you celebrating?
                          </Typography> */}

                      <Box sx={{ mt: 0 }}>
                        {isGoodMovesTuesday && (
                          <Box sx={{ mb: 3 }}>
                            <Typography
                              sx={{
                                fontSize: "12px",
                                fontWeight: 500,
                                color: "#2B2B2B",
                                mb: 1,
                              }}
                            >
                              Chess Level *
                            </Typography>
                            <Grid container spacing={1.5}>
                              {chessLevels.map((level) => {
                                const selected = referalCode === level;
                                return (
                                  <Grid item xs={4} key={level}>
                                    <Button
                                      fullWidth
                                      onClick={() => setReferalCode(level)}
                                      variant={selected ? "contained" : "outlined"}
                                      sx={{
                                        borderRadius: "8px",
                                        py: 1.2,
                                        fontSize: "12px",
                                        fontWeight: 600,
                                        textTransform: "none",
                                        borderColor: selected ? "#BC172F" : "#d7d7d7",
                                        color: selected ? "#fff" : "#2B2B2B",
                                        bgcolor: selected ? "#BC172F" : "#fff",
                                        "&:hover": {
                                          borderColor: "#BC172F",
                                          bgcolor: selected ? "#a01428" : "rgba(188, 23, 47, 0.04)",
                                        },
                                      }}
                                    >
                                      {level}
                                    </Button>
                                  </Grid>
                                );
                              })}
                            </Grid>
                          </Box>
                        )}
                      {
                        !isGoodMovesTuesday && (
                          <Box sx={{ mt: 0 }}>
                          <DietaryOptions
                            updateDietary={(value) => setDietary(value)}
                          />
                        </Box>
                        )
                      }
                        <Box sx={{ mt: 3 }}>
                          <Typography
                            sx={{ fontWeight: 500, fontSize: "12px" }}
                          >
                            Do you have any special request? (Optional)
                          </Typography>

                          <CustomInput
                            value={specialRequest}
                            onChange={(e) => setSpecialRequest(e.target.value)}
                            placeholder="Your input here"
                            multiline
                            fullWidth
                            margin="dense"
                            minRows={2}
                          />
                        </Box>
                      </Box>
                    </Box>
                  </Grid>
                  {!isGoodMovesTuesday && (
                    <Grid item md={12} xs={12}>
                      <CustomInput
                        label="Referral Code"
                        placeholder="Enter referral code"
                        value={referalCode}
                        onChange={(e) => setReferalCode(e.target.value)}
                      />
                    </Grid>
                  )}
                </Grid>
              </Box>

              <Box sx={{ my: 4 }}>
                <Box sx={{ display: "flex", columnGap: 1 }}>
                  <Checkbox />
                  <Typography sx={{ fontSize: "13px" }}>
                    By Clicking on the Complete button You have read and agree
                    to the{" "}
                    <span style={{ color: "#BC172F" }}>Terms & Conditions</span>{" "}
                    and <span style={{ color: "#BC172F" }}>Privacy Policy</span>
                  </Typography>
                </Box>

                {isMultiTicket || ticket_id ? (
                  <Button
                    disabled={
                      !firstName ||
                      !lastName ||
                      !email ||
                      !phone ||
                      chargeLoading ||
                      (isMultiTicket && totalSelectedQuantity === 0) ||
                      (isGoodMovesTuesday && !referalCode)
                    }
                    onClick={() => {
                      handleSendBooking();
                    }}
                    variant="contained"
                    fullWidth
                    sx={{ mt: 3, borderRadius: "10px", fontWeight: 500, py: 2 }}
                  >
                    {isFreeEvent ? "Book Event" : "Make Payment"}
                  </Button>
                ) : (
                  <Button
                    disabled={
                      !firstName ||
                      !lastName ||
                      !email ||
                      !phone ||
                      (isGoodMovesTuesday && !referalCode)
                    }
                    onClick={() => {
                      handleSendBookingNoPayment();
                    }}
                    variant="contained"
                    fullWidth
                    sx={{ mt: 3, borderRadius: "10px", fontWeight: 500, py: 2 }}
                  >
                    Book Event
                  </Button>
                )}
              </Box>
            </Box>
          </Grid>
          {/* <Grid item md={1}></Grid> */}
          <Grid item md={12}>
            <Box>
              <Box
                sx={{
                  bgcolor: "#fff",
                  border: "1px solid #dadada",
                  borderRadius: "8px",
                }}
              >
                <Box sx={{ p: 2, py: 3, borderBottom: "1px solid #dadada" }}>
                  <Typography sx={{ fontSize: "13px", fontWeight: 500 }}>
                    {name}
                  </Typography>
                </Box>
                <Box sx={{ p: 2, pb: 5 }}>
                  <Box sx={{ display: "flex", columnGap: 2 }}>
                    <Typography sx={{ fontWeight: 600, fontSize: "12px" }}>
                      Description:
                    </Typography>
                    <Box>
                      <Typography
                        sx={{
                          color: "#717171",
                          fontSize: "12px",
                          fontWeight: 300,
                          display: "-webkit-box",
                          overflowWrap: "anywhere",
                          wordBreak: "break-word",
                        }}
                      >
                        {isMultiTicket
                          ? selectedTickets?.[0]?.Description?.replace(
                              /<[^>]*>/g,
                              "",
                            )
                          : data?.Description?.replace(/<[^>]*>/g, "")}
                      </Typography>
                    </Box>
                  </Box>
                  <Divider sx={{ my: 2 }} />
                  {isMultiTicket ? (
                    <Box sx={{ mt: 2 }}>
                      {selectedTickets.map((ticket) => {
                        const qty = ticketQuantities[ticket.TicketId] || 0;
                        return (
                          <Stack
                            key={ticket.TicketId}
                            direction="row"
                            spacing={2}
                            align="center"
                            sx={{ mt: 1.5 }}
                          >
                            <img src={guest} width={20} />
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                columnGap: 2,
                                justifyContent: "space-between",
                                width: "100%",
                              }}
                            >
                              <Box
                                sx={{
                                  width: "100%",
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "start",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    fontWeight: 600,
                                  }}
                                >
                                  {ticket?.TicketType}
                                </Typography>
                                <Typography sx={{ fontSize: "11px", mt: 0.5 }}>
                                  ₦{ticket?.TicketCost.toLocaleString()}
                                </Typography>
                              </Box>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  columnGap: 2,
                                }}
                              >
                                <IconButton
                                  onClick={() =>
                                    handleDecreaseQuantity(ticket.TicketId)
                                  }
                                  sx={{
                                    borderRadius: 1,
                                    border: "0.5px solid #1a1a1a",
                                    fontSize: "14px",
                                    fontWeight: 900,
                                  }}
                                >
                                  <TiMinus />
                                </IconButton>
                                <Typography
                                  sx={{
                                    fontSize: "13px",
                                    fontWeight: 600,
                                  }}
                                >
                                  {qty}
                                </Typography>
                                <IconButton
                                  onClick={() =>
                                    handleIncreaseQuantity(
                                      ticket.TicketId,
                                      ticket.TicketLeft,
                                    )
                                  }
                                  disabled={
                                    (maxTicketCount &&
                                      totalSelectedQuantity >= maxTicketCount) ||
                                    (ticket.TicketLeft !== undefined &&
                                      qty >= ticket.TicketLeft)
                                  }
                                  sx={{
                                    borderRadius: 1,
                                    border: "0.5px solid #1a1a1a",
                                    fontSize: "14px",
                                    fontWeight: 900,
                                  }}
                                >
                                  <TiPlus />
                                </IconButton>
                              </Box>
                            </Box>
                          </Stack>
                        );
                      })}
                    </Box>
                  ) : (
                    <Stack
                      direction="row"
                      spacing={4}
                      align="center"
                      sx={{ mt: 2 }}
                    >
                      <img src={guest} width={20} />
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          columnGap: 2,
                        }}
                      >
                        <IconButton
                          onClick={handleSub}
                          sx={{
                            borderRadius: 1,
                            border: "0.5px solid #1a1a1a",
                            fontSize: "14px",
                            fontWeight: 900,
                          }}
                          disabled={loading}
                        >
                          <TiMinus />
                        </IconButton>
                        <Typography sx={{ fontSize: "13px", fontWeight: 600 }}>
                          {count}
                          {isShiroEvent ? (
                            <>{count === 1 ? " Guest" : " Guests"}</>
                          ) : (
                            <>{count === 1 ? " Ticket" : " Tickets"}</>
                          )}
                        </Typography>
                        <IconButton
                          disabled={
                            loading ||
                            data?.TicketLeft <= count ||
                            (maxTicketCount && count >= maxTicketCount)
                          }
                          onClick={handleAdd}
                          sx={{
                            borderRadius: 1,
                            border: "0.5px solid #1a1a1a",
                            fontSize: "14px",
                            fontWeight: 900,
                          }}
                        >
                          <TiPlus />
                        </IconButton>
                      </Box>
                    </Stack>
                  )}
                  {/* <Stack
                    direction="row"
                    spacing={2}
                    align="center"
                    sx={{ mt: 2 }}
                  >
                    <img src={clock} />
                    <Typography sx={{ fontSize: "13px" }}>6:00 PM</Typography>
                  </Stack> */}
                </Box>
              </Box>
              {isMultiTicket ? (
                <Box
                  sx={{
                    bgcolor: "#fff",
                    border: "1px solid #dadada",
                    mt: 5,
                    borderRadius: "8px",
                  }}
                >
                  <Box sx={{ p: 2, py: 2, borderBottom: "1px solid #dadada" }}>
                    <Typography
                      sx={{
                        fontSize: "13px",
                        fontWeight: 500,
                        color: "#BC172F",
                      }}
                    >
                      Order Summary
                    </Typography>
                  </Box>
                  <Box sx={{ p: 2, py: 2, borderBottom: "1px solid #dadada" }}>
                    {selectedTickets.map((ticket) => {
                      const qty = ticketQuantities[ticket.TicketId] || 0;
                      const lineTotal = (ticket.TicketCost || 0) * (qty || 0);
                      return (
                        <Box
                          key={ticket.TicketId}
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            mb: 1,
                          }}
                        >
                          <Typography sx={{ fontSize: "12px" }}>
                            {ticket.TicketType}{" "}
                            <b style={{ fontSize: "14px", marginLeft: 2 }}>
                              x {qty}
                            </b>
                          </Typography>
                          <Typography
                            sx={{ fontSize: "13px", fontWeight: 500 }}
                          >
                            ₦{lineTotal.toLocaleString()}
                          </Typography>
                        </Box>
                      );
                    })}
                  </Box>

                  <Box sx={{ p: 1 }}>
                    <Box
                      sx={{
                        p: 1,
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography sx={{ fontSize: "13px", fontWeight: 500 }}>
                        Charges
                      </Typography>
                      {chargeLoading ? (
                        <Skeleton variant="sqare" width="30%" />
                      ) : (
                        <Typography sx={{ fontSize: "13px", fontWeight: 500 }}>
                          ₦{charges?.ExtraCharge?.toLocaleString()}
                        </Typography>
                      )}
                    </Box>
                  {
                    charges?.taxPrice > 0 && (
                        <Box
                      sx={{
                        p: 1,
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography sx={{ fontSize: "13px", fontWeight: 500 }}>
                        Tax
                      </Typography>
                      {chargeLoading ? (
                        <Skeleton variant="sqare" width="30%" />
                      ) : (
                        <Typography sx={{ fontSize: "13px", fontWeight: 500 }}>
                          ₦{charges?.taxPrice?.toLocaleString()}
                        </Typography>
                      )}
                    </Box>
                    )
                  }
                    <Box
                      sx={{
                        p: 1,
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography sx={{ fontSize: "13px", fontWeight: 500 }}>
                        Total
                      </Typography>
                      <Typography sx={{ fontSize: "13px", fontWeight: 500 }}>
                        {chargeLoading ? (
                          <CircularProgress size={20} />
                        ) : (
                          ` ₦${(charges?.TotalPrice)?.toLocaleString()}`
                        )}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              ) : (
                ticket_id && (
                  <Box
                    sx={{
                      bgcolor: "#fff",
                      border: "1px solid #dadada",
                      mt: 5,
                      borderRadius: "8px",
                    }}
                  >
                    <Box
                      sx={{ p: 2, py: 2, borderBottom: "1px solid #dadada" }}
                    >
                      <Typography
                        sx={{
                          fontSize: "13px",
                          fontWeight: 500,
                          color: "#BC172F",
                        }}
                      >
                        Order Summary
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        p: 2,
                        py: 3,
                        display: "flex",
                        justifyContent: "space-between",
                        borderBottom: "1px solid #dadada",
                      }}
                    >
                      {loading ? (
                        <Skeleton variant="sqare" width="100%" />
                      ) : (
                        <Typography sx={{ fontSize: "13px" }}>
                          {name} -{" "}
                          <b>
                            {data?.TicketName} {!isShiroEvent && "ticket"}
                          </b>
                        </Typography>
                      )}
                    </Box>

                    <Box sx={{ p: 1 }}>
                      <Box
                        sx={{
                          p: 1,
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography sx={{ fontSize: "13px", fontWeight: 500 }}>
                          Total
                        </Typography>
                        {chargeLoading ? (
                          <Skeleton variant="sqare" width="30%" />
                        ) : (
                          <Typography
                            sx={{ fontSize: "13px", fontWeight: 500 }}
                          >
                            ₦{charges?.ActualPrice?.toLocaleString()}
                          </Typography>
                        )}
                      </Box>
                      <Box
                        sx={{
                          p: 1,
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography sx={{ fontSize: "13px", fontWeight: 500 }}>
                          Charges
                        </Typography>
                        {chargeLoading ? (
                          <Skeleton variant="sqare" width="30%" />
                        ) : (
                          <Typography
                            sx={{ fontSize: "13px", fontWeight: 500 }}
                          >
                            ₦{charges?.ExtraCharge?.toLocaleString()}
                          </Typography>
                        )}
                      </Box>
                      <Box
                        sx={{
                          p: 1,
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography sx={{ fontSize: "13px", fontWeight: 500 }}>
                          Amount Due
                        </Typography>
                        {chargeLoading ? (
                          <Skeleton variant="sqare" width="30%" />
                        ) : (
                          <Typography
                            sx={{ fontSize: "13px", fontWeight: 500 }}
                          >
                            ₦{charges?.TotalPrice?.toLocaleString()}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  </Box>
                )
              )}

              <Box
                sx={{
                  mt: 2,
                  display: "flex",
                  columnGap: 2,
                  width: { md: "100%", xs: "100%" },
                  alignItems: "center",
                }}
              >
                <Checkbox checked />
                <Typography sx={{ fontSize: "13px" }}>
                  Get notifications of offers and other relevant emails from
                  this restaurant
                </Typography>
              </Box>
              <Box
                sx={{
                  mt: 2,
                  display: "flex",
                  columnGap: 2,
                  width: { md: "100%", xs: "100%" },
                  alignItems: "center",
                }}
              >
                <Checkbox />
                <Typography sx={{ fontSize: "13px" }}>
                  I would like to receive news and updates from this business.
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>

      {isloading && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}

      <Modal
        open={open}
        // onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {isSuccessful && (
            <>
              <Box
                sx={{
                  bgcolor: "primary.success",
                  p: 2,
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <img src={gifg} width={150} />
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: "20px",
                    fontFamily: "optima",
                  }}
                >
                  {
                    isGoodMovesTuesday ? "Pending Approval " : "Booking Confirmed"
                  }
                  
                </Typography>
               {
                !isGoodMovesTuesday && (
                  <Typography sx={{ fontSize: "13px", textAlign: "center" }}>
                  Please check your inbox for a confirmation email and your
                  ticket.
                </Typography>
                )
               }
              </Box>
            </>
          )}
          {errorMessage && (
            <>
              <Box sx={{ bgcolor: "red", p: 2 }}>
                <Typography sx={{ color: "#fff", fontWeight: 600 }}>
                  Error Message
                </Typography>
              </Box>
              <Box sx={{ height: "40px", p: 2 }}>
                <Typography color="error">{errorMessage}</Typography>
              </Box>
            </>
          )}

          <Box align="center">
            <Button sx={{ my: 3 }} onClick={handleClose}>
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default Booking;
